(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------

(function($) {

	if (typeof window.Theme == 'undefined') window.Theme = {};

	Theme = {

		settings: {},

		/*
		 * Theme init
		 */
		init: function() {

			this.shareLinks();

			this.mobileMenu();

			this.slider();

			this.sliderMobile();

			this.equalizeHeight();

			this.smoothScroll();

			$(window).smartresize(() => {
				this.sliderMobile();
				this.equalizeHeight();
			});

		},

		shareLinks: function() {
			$('a[data-share]').share({
    		counts: false
    	});
		},				

		mobileMenu: function() {

			let $headerNav = $('nav.primary');

			$('#mobile-menu-toggle').click(function() {

				$headerNav.toggleClass('-open')
				$(this).toggleClass('-x')

			});

			// Submenu toggle
			// ----------------------------
			
			let $submenuItem = $('#menu-primary').find('li.menu-item-has-children > a')

			$submenuItem.each(function() {
				$(this).append('<span class="submenu-toggle"></span>')
			})

			let $submenuToggle = $headerNav.find('.submenu-toggle');

			$submenuToggle.click(function(e) {
				e.preventDefault();

				// $(this).parents().parents('.menu-primary').find('.menu-item-has-children.-open').removeClass('-open')
				$(this).parents('.menu-item-has-children').toggleClass('-open')
				
			})

			
		},


		slider: function() {

			$('.slider-simple').slick({
				arrows: true,
				dots: true,
				fade: true,
				prevArrow: '<button type="button" class="slick-prev icon-left-open-big"></button>',
				nextArrow: '<button type="button" class="slick-next icon-right-open-big"></button>',
				asNavFor: '.slider-simple-content'
			})

			$('.slider-simple-content').slick({
				arrows: false,
				dots: false,
				fade: true,
				// adaptiveHeight: true,
				asNavFor: '.slider-simple'
			})


		},

		sliderMobile: function() {
			
			if($(window).width() > 736) return;

			$('.slider-swipe').slick({
				centerMode: true,
				centerPadding: '10px',
				slidesToShow: 3,
				responsive: [
				{
				  breakpoint: 480,
				  settings: {
				    arrows: false,
				    centerMode: true,
				    centerPadding: '40px',
				    slidesToShow: 1,
				    adaptiveHeight: false
				  }
				}
				]
			})
		},

		equalizeHeight: function() {
			if( $('[data-equal-heights]').length < 1 ) return;

		  function setEqualHeights() {
		    $('[data-equal-heights]').each(function () {

		      // _this.setHeights();

		      var eqSelectors = $(this).data('equal-heights'),
		          $eqSelectors = $(this).find(eqSelectors),
		          mobile = $(this).data('equal-mobile') ? true : false;

		      // Cache the highest
		      var highestBox = 0;

		      if ($(window).width() < 737 && mobile != true) {

		        $($eqSelectors, this).each(function () {
		          $(this).css('height', '');
		        });

		      } else {

		        // Select and loop the elements you want to equalise
		        $($eqSelectors, this).each(function () {

		          // Remove height if set from before to account for resize
		          $(this).css('height', '');

		          // If this box is higher than the cached highest then store it
		          if ($(this).height() > highestBox) {
		            highestBox = $(this).height();
		          }
		        });

		        // Set the height of all those children to whichever was highest 
		        $($eqSelectors, this).height(highestBox);
		      }
		    });
		  }

		  setEqualHeights();

		},


		smoothScroll: function() {
			
			var offset = 0

			$('body').on('click', 'a.scroll', function (e) {

				var url = $(this).attr('href');

				if (typeof url === typeof undefined || url === false) return;

			    if (url.slice(0, 1) == "#") {
			   		
			   		e.preventDefault();
			   		$('html, body').stop().animate({
				      scrollTop: $(url).offset().top - offset
				    }, 1000);
			    }
			});


			// if(window.location.hash) {
	  //     var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
	      
	  //     if(!exists('#'+hash)) return;

   //   		$('html, body').animate({
  	//       scrollTop: $('#'+hash).offset().top - offset
  	//     }, 1000);
	      
		 //  } else {
		    
		 //  }
		},



	};
	
	module.exports = Theme;

})(jQuery);
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/theme.js","/modules")